import React from 'react';
import './Companies.css';

const companies = [
  { name: 'UBA', logoSrc: '/UBA%20logo.png' },
  { name: 'Solv', logoSrc: '/Solvlogo.svg' },
  { name: 'Creative', logoSrc: '/creative%20logo.png' },
];

export default function Companies() {
  return (
    <section className="companies" aria-label="Companies worked with">
      <div className="container companies__inner">
        <div className="companies__label">
          Delivered results for teams and organisations including:
        </div>
        <div className="companies__logos" aria-label="Company logos">
          {companies.map((c) => (
            <div className="companies__logo" key={c.name}>
              {c.logoSrc ? (
                <img className="companies__logoImg" src={c.logoSrc} alt={c.name} loading="lazy" />
              ) : (
                <span className="companies__logoText">{c.name}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
